// src/context/AuthContext.tsx

import React, { createContext, useState, useEffect, ReactNode } from "react";
import { User } from "../types/auth";
import { AUTH_UNAUTHORIZED_EVENT } from "../utils/authSession";

interface AuthContextType {
  user: User | null;
  accessToken: string | null; // نام به accessToken تغییر کرد
  isLoading: boolean;
  isAuthenticated: boolean;
  setUser: (user: User | null) => void;
  setAccessToken: (token: string | null) => void; // نام تابع به setAccessToken تغییر کرد
  setIsLoading: (loading: boolean) => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [user, setUser] = useState<User | null>(null);
  const [accessToken, setAccessToken] = useState<string | null>(null); // نام متغیر تغییر کرد
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem("access_token"); // کلید تغییر کرد
    const storedUser = localStorage.getItem("user");

    if (storedToken && storedUser) {
      setAccessToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    const resetAuthState = () => {
      setAccessToken(null);
      setUser(null);
    };

    window.addEventListener(AUTH_UNAUTHORIZED_EVENT, resetAuthState);
    return () => {
      window.removeEventListener(AUTH_UNAUTHORIZED_EVENT, resetAuthState);
    };
  }, []);

  const isAuthenticated = !!user;

  const value = {
    user,
    accessToken, // نام متغیر در value نیز تغییر کرد
    isLoading,
    isAuthenticated,
    setUser,
    setAccessToken, // نام تابع در value نیز تغییر کرد
    setIsLoading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
